export default "__VITE_ASSET__DYocUml3__"